import AuthError from './authError';

export default class UnhandledAuthError extends AuthError {}
